import type { Product } from './product-types';

export function partitionSearchResults(products: Product[], allResultsLoaded = true) {
  const seen = new Set<string>();
  const unique = products.filter(p => !seen.has(p.id) && Boolean(seen.add(p.id)));
  const unavailable = (p: Product) => ['unavailable','out_of_stock','off_shelf','not_sold'].includes(p.saleStatus || '');
  // A complete all-unavailable collection is still useful catalogue content.
  // Wait for all API batches before deciding that there are no available items.
  if (allResultsLoaded && unique.length && unique.every(unavailable)) {
    return { visible: unique, folded: [] };
  }
  const visible = unique.filter(p => !unavailable(p) || p.entryKind === "perfume" || p.exactMatch || p.defaultVisible);
  const ids = new Set(visible.map(p => p.id));
  return { visible, folded: unique.filter(p => !ids.has(p.id)) };
}

export function productPage<T>(products: T[], requestedPage: number) {
  const pages = Math.max(1, Math.ceil(products.length / 5));
  const page = Math.max(0, Math.min(requestedPage, pages - 1));
  return { page, pages, items: products.slice(page * 5, page * 5 + 5) };
}

export function parsePageNumber(value: string, totalPages: number): number | null {
  const text = value.trim();
  if (!/^\d+$/.test(text)) return null;
  const page = Number(text);
  return Number.isSafeInteger(page) && page >= 1 && page <= totalPages ? page - 1 : null;
}
